import { GlobalController } from 'src/shared/global/GlobalController'
import { JtechAxios } from 'src/plugins/axios'
export default {
  uploadFile: async function (url, form) {
    const formData = new FormData()
    form.forEach(objeto => {
      Object.entries(objeto).forEach(([key, value]) => {
        formData.append(key, value)
      })
    })

    return await JtechAxios.request().post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data; boundary=boundjnmtfkjmutgu'
      },
      transformRequest: [
        (data, headers) => {
          const globalController = GlobalController.getInstance()
          if (globalController && globalController.authResp && globalController.authResp.token) { headers.Authorization = 'Bearer ' + globalController.authResp.token }
          return data
        }
      ]
    })
  }
}
